import { useState, type ReactNode } from 'react';
import { ChevronIcoon, VinkIcoon } from '@/components/layout/Iconen';
import './form.css';

interface SectieProps {
  nummer: number;
  titel: string;
  /** Er staat inhoud in deze sectie. */
  ingevuld?: boolean;
  /**
   * Wat er in deze sectie staat, in één regel.
   *
   * Dit doet het echte werk van de kop: een coach hoeft een sectie niet te
   * openen om te weten of hij er moet zijn. "Aanwezig · 2 adviezen · 1,2 m³"
   * zegt genoeg om door te scrollen.
   */
  samenvatting?: string;
  standaardOpen?: boolean;
  children: ReactNode;
}

/** Inklapbare formuliersectie; houdt lange formulieren op mobiel overzichtelijk. */
export function Sectie({
  nummer,
  titel,
  ingevuld = false,
  samenvatting,
  standaardOpen = false,
  children,
}: SectieProps): JSX.Element {
  const [open, setOpen] = useState(standaardOpen);

  return (
    <section id={`sectie-${nummer}`} className={`sectie${open ? ' sectie--open' : ''}`}>
      <button
        type="button"
        className="sectie__kop"
        onClick={() => setOpen((huidig) => !huidig)}
        aria-expanded={open}
      >
        {/* De hexagon is de vorm van het merk. Gevuld met een vinkje als er
            iets staat, open als de sectie nog leeg is. */}
        <span
          className={`sectie__merk${ingevuld ? ' sectie__merk--ingevuld' : ''}`}
          aria-hidden="true"
        >
          {ingevuld ? <VinkIcoon /> : nummer}
        </span>

        <span className="sectie__tekst">
          <span className="sectie__titel">{titel}</span>
          {samenvatting && <span className="sectie__samenvatting">{samenvatting}</span>}
        </span>

        {ingevuld && <span className="visueel-verborgen">ingevuld</span>}
        <ChevronIcoon className={`sectie__chevron${open ? ' sectie__chevron--open' : ''}`} />
      </button>

      {open && <div className="sectie__inhoud">{children}</div>}
    </section>
  );
}
